import request from '@/axios/binet';

// 根据bs的token获取bi对应的token
export function tokenOrToken(data) {
    return request({
        url: '/auth',
        headers: { isToken: false },
        method: "post",
        data
    });
}

// 加载签名
export function allBIMenus(data) {
    return request({
        url: '/dataset_config',
        method: 'get',
        data
    })
}